import React, { FC, useEffect, useRef } from "react";

export interface AuiSortByProps {
  activecolor?: string;
  inactivecolor?: string;
  width?: number;
  height?: number;
  svgclass?: string;
  onClick?: (detail: any) => void;
}

const AuiSortBy: FC<AuiSortByProps> = ({
  activecolor,
  inactivecolor,
  width,
  height,
  svgclass,
  onClick,
}) => {
  const sortByRef = useRef<HTMLAuiSortbyElement>(null);

  const handleSortBy = (event: CustomEvent) => {
    if (onClick) {
      onClick(event?.detail);
    }
  };

  useEffect(() => {
    const sortByElement = sortByRef.current;

    sortByElement?.addEventListener("auiSortBy", handleSortBy as EventListener);

    return () => {
      sortByElement?.removeEventListener(
        "auiSortBy",
        handleSortBy as EventListener
      );
    };
  }, [handleSortBy]);

  return (
    <aui-sortby
      ref={sortByRef}
      activecolor={activecolor}
      inactivecolor={inactivecolor}
      width={width}
      height={height}
      svgclass={svgclass}
    ></aui-sortby>
  );
};

export default AuiSortBy;
